import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { AiGenerationLoadingContent } from 'components/AIGenerationLoadingContent'
import {
  MOBILE_HEADER_WITH_GAP_HEIGHT,
  SMALL_DESKTOP_SIZE_BREAKPOINT
} from 'consts'

export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-right: 14px;
  padding-top: 16px;
  box-sizing: content-box;
  gap: 16px;
  ${customizeVerticalScrollbarThumbMixin()};

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    overflow-y: visible;
    height: auto;
    min-height: calc(100dvh - ${MOBILE_HEADER_WITH_GAP_HEIGHT}px - 80px);
  }
`

export const VideoItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${COLORS.white};
  border-bottom: 1px solid ${COLORS.borderColor};

  &:last-child {
    border-bottom: none;
  }
`

export const VideoSkeleton = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    ${COLORS.secondaryUltraLight} 25%,
    ${COLORS.secondaryLight} 50%,
    ${COLORS.secondaryUltraLight} 75%
  );
  background-size: 400% 100%;
  animation: loading 1.5s infinite;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`

export const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`

export const PlayButton = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
    fill: ${COLORS.primaryDark};
    margin-left: 2px;
  }
`

export const LoadingWrapper = styled(AiGenerationLoadingContent)`
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    & > :first-child {
      width: 100% !important;
    }
  }
`
